function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.9252 14.7798C22.9924 14.57 23.2268 14.3999 23.4496 14.3999H28.245C28.4674 14.3999 28.5785 14.568 28.4952 14.7704L25.9998 20.8306C25.9156 21.0352 26.0296 21.2011 26.2483 21.2011H30.2471C30.4686 21.2011 30.537 21.34 30.3962 21.516L22.0468 31.9527C21.4943 32.6433 21.2639 32.5199 21.5311 31.6801L23.7266 24.7799C23.7931 24.571 23.6646 24.4017 23.4487 24.4017H20.2445C20.0245 24.4017 19.9018 24.2281 19.9678 24.0218L22.9252 14.7798Z",
  fill: "black"
});

var SvgActivityFeed = function SvgActivityFeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 24,
    r: 23.5,
    fill: "white",
    fillOpacity: 0.75,
    style: {
      stroke: "var(--color-primary)"
    }
  }), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivityFeed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activity-feed.8820cc9a.svg";
export { ForwardRef as ReactComponent };